import React, { Fragment } from 'react'
import { Segment, Button, Loader, Divider } from 'semantic-ui-react'
import { getAuthor } from './utils'

const StoryStartScreen = (props) => {
  const {
    story,
    soundsLoaded,
    soundsProgress,
    onStart,
    onShowCredits
  } = props
  const hasSounds = story.sounds && Object.keys(story.sounds).length > 0

  const isLoaded = soundsLoaded || !hasSounds

  return (
    <Segment id="story-start-screen" inverted padded='very' style={{ width: 350, padding: '2.5em 3em' }}>
      { story ? (
        <Fragment>
          <div style={{ fontStyle: 'italic' }}>Moiki présente</div>
          <h2 style={{ marginTop: '0.3em', marginBottom: '0.3em' }}>{ story.meta.name }</h2>
          <div style={{ fontStyle: 'italic', color: '#9e9a9a', marginBottom: '1em' }}>Une histoire de { getAuthor(story.meta) }</div>
          { (story.meta.imageLocal || story.meta.image) && (
            <div>
              <img style={{maxHeight: 225, overflow: 'hidden', width: '100%'}} src={story.meta.imageLocal || story.meta.image} alt='' className='cover' />
            </div>
          )}
          <p style={{ marginTop: '0.3em' }}>{ story.meta.description }</p>
          <div style={{ height: '3em', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {(isLoaded) ? (
              <Button id="play-button" onClick={() => onStart({sounds: true})} primary icon='play' circular size='huge' style={{ margin: '.75em' }} />
            ) : (
              <Segment inverted style={{ margin: '1.8em' }}>
                <div>téléchargement des sons<br/>{ soundsProgress.toFixed(0) }%</div>
                <div style={{ width: '100%', height: 4, position: 'relative', background: '#666', display: 'block', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: soundsProgress + '%', background: '#2185D0', display: 'block'  }} />
                </div>
              </Segment>
            )}
          </div>
          <Divider inverted />
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button id="credits-button" className='link-button' basic inverted size='mini' onClick={onShowCredits}>voir les crédits</Button>
          </div>
         </Fragment>
      ) : (
        <Loader active={true} />
      )}
    </Segment>
  )
}

export default StoryStartScreen